
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as authnsElNSNj_rLQlIWUIay965JlFLujs_lJYGW9xdWJ0nkMeta } from "/src/app/pages/auth.vue?macro=true";
import { default as homeGucZrzP0_QKj87xJzPe0gV4vRjlFZdkUP7_BIcbMLoUMeta } from "/src/app/pages/home.vue?macro=true";
import { default as locationsYeEC9j3D3_UW4EiOSLzdIUdgPYh5v0IUPr_ohIMrHpcMeta } from "/src/app/pages/locations.vue?macro=true";
import { default as order_45trackingL2lI2LE_zHCbKCkv4hFxxMNXbFaPaAHt4QEQ0Ltkyk0Meta } from "/src/app/pages/order-tracking.vue?macro=true";
import { default as loyalty_45programpYOATZO_0gBg2882Fptq9eNx_memHfhfjhWYoVP_0gEMeta } from "/src/app/pages/loyalty-program.vue?macro=true";
import { default as menub8bKzuPRlZ_9YH50y9h_SsJEse29eUsBx2KJnF9UASEMeta } from "/src/app/pages/order-online/menu.vue?macro=true";
import { default as profilegreHDS8hKTUNZvK2Vix20xbuyCE1A9yiUEogX7L_EkcMeta } from "/src/app/pages/my-account/profile.vue?macro=true";
import { default as menusEtoogcb_QjPrqFwB3FMORrZSGMAkq7FOvzlTgIFW0doMeta } from "/src/app/pages/order-online/menus.vue?macro=true";
import { default as outletcq5iF65dbrJF7kz0kknxZ_Eq4uDR3ZLOaufga_sq7IoMeta } from "/src/app/pages/order-online/outlet.vue?macro=true";
import { default as addressesmjGjmMxKhAkPyLrbfT7V18eAufCP_xFgyKqFscMl5uAMeta } from "/src/app/pages/my-account/addresses.vue?macro=true";
import { default as my_45account_o2LZOiCMb1uGkZfV1HbzspUlw9twz8bVDjdQhesgJcMeta } from "/src/app/pages/my-account/my-account.vue?macro=true";
import { default as order_45historyNVQ7O7DLtFM4XQn_yQJkKPOzyGOcSci4VDO3DBFMeZYMeta } from "/src/app/pages/my-account/order-history.vue?macro=true";
import { default as select_45modedDKetUV3IQtgPP42k1gMs7ajg1yPgT14U8P2VqcVXosMeta } from "/src/app/pages/order-online/select-mode.vue?macro=true";
export default [
  {
    name: "auth",
    path: "/auth",
    component: () => import("/src/app/pages/auth.vue")
  },
  {
    name: "home",
    path: "/home",
    component: () => import("/src/app/pages/home.vue")
  },
  {
    name: "locations",
    path: "/locations",
    component: () => import("/src/app/pages/locations.vue")
  },
  {
    name: "order-tracking",
    path: "/order-tracking",
    component: () => import("/src/app/pages/order-tracking.vue")
  },
  {
    name: "loyalty-program",
    path: "/loyalty-program",
    component: () => import("/src/app/pages/loyalty-program.vue")
  },
  {
    name: "order-online-menu",
    path: "/order-online/menu",
    component: () => import("/src/app/pages/order-online/menu.vue")
  },
  {
    name: "my-account-profile",
    path: "/my-account/profile",
    component: () => import("/src/app/pages/my-account/profile.vue")
  },
  {
    name: "order-online-menus",
    path: "/order-online/menus",
    component: () => import("/src/app/pages/order-online/menus.vue")
  },
  {
    name: "order-online-outlet",
    path: "/order-online/outlet",
    component: () => import("/src/app/pages/order-online/outlet.vue")
  },
  {
    name: "my-account-addresses",
    path: "/my-account/addresses",
    component: () => import("/src/app/pages/my-account/addresses.vue")
  },
  {
    name: "my-account-my-account",
    path: "/my-account/my-account",
    component: () => import("/src/app/pages/my-account/my-account.vue")
  },
  {
    name: "my-account-order-history",
    path: "/my-account/order-history",
    component: () => import("/src/app/pages/my-account/order-history.vue")
  },
  {
    name: "order-online-select-mode",
    path: "/order-online/select-mode",
    component: () => import("/src/app/pages/order-online/select-mode.vue")
  }
]